import { render, staticRenderFns } from "./gs-translation-field.vue?vue&type=template&id=90e30a8e"
import script from "./gs-translation-field.vue?vue&type=script&lang=ts"
export * from "./gs-translation-field.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports